module.exports = __webpack_public_path__ + "static/phoneAndroid-8394e1cdade23dbe83ee44bcc276584b.svg";